"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getUserGroupId = function getUserGroupId(user) {
  var _user$groups = user.groups,
      groups = _user$groups === void 0 ? [] : _user$groups;

  if (groups.length) {
    var group = groups[0] && groups[0].group;
    var groupId = group.parent ? group.parent : group._id;
    return groupId.toString();
  }

  return null;
};

var _default = getUserGroupId;
exports["default"] = _default;
//# sourceMappingURL=getUserGroupId.js.map